<template>
    <div class="header">
        <div class="l-content">
            <!-- <h3>大洲官网</h3> -->
            <img class="headerimg" src="../assets/header-default.png" alt="">
        </div>
        <div class="r-content">
            <el-menu :default-active="activeindex" router class="el-menu-demo" mode="horizontal" 
            text-color="#333333"
            active-text-color="#1d62a9"
            unique-opened
            @select="handleSelect">
                <el-menu-item index="home">首页</el-menu-item>
                <el-menu-item index="message">活动</el-menu-item>  
                <el-menu-item index="exchange" >两岸交流</el-menu-item>
                <el-menu-item index="master" >大师作品</el-menu-item>
                <el-menu-item index="introduction" >园区简介</el-menu-item>
                <el-menu-item index="created" >园区文创</el-menu-item>
            </el-menu>
        </div>
    </div>
</template>

<script>

import headerdefault from '../assets/header-default.png'

export default {
    name: 'CommonHeader',
    data() {
        return {
            activeindex:'home',
        }
    },
    computed: {
        userinfo() {
            return this.$store.state.userinfo
        },
        curdate() {
            const date = new Date()
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            var nowDate = year + "年" + month + "月" + day + "日";
            return nowDate;
        },
        avatarurl() {
            return this.userinfo.avatar ? this.userinfo.avatar : headerdefault
        }
    },
    methods: {
        handleSelect(command) {
            console.log('click on menu item ' + command);
            this.activeindex = command
            if (command === 'about') {
                this.$router.push('/home/'+command)
            } else{
                this.$router.push('/'+command)
            }

            //当前的路由和跳转的路由不一致的时候跳转
            // const cpath = '/'+command
            // console.log('this.$route.path' + this.$route.path + cpath);
            // if(this.$route.path !== cpath ){               
                // this.$router.push(cpath)
            // }
        }
    },
    mounted() {
        console.log('CommonHeader mounted');
        console.log(this.$route)
        // this.$store.commit('GetUserInfoData')
        this.activeindex = this.$route.name
    },
}
</script>

<style lang="less" scoped>
.header {
    padding: 0 40px;
    background-color: #fff;
    height: 14.58vw ; 
    min-height: 140px;
    max-height: 180px;
    min-width: 850px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .l-content {
        margin-left: 6.2vw;
        margin-bottom: 14px;
        .headerimg {
            width: 17.2vw;
            // height: 9.3vw;
            max-width: 205px;
            min-width: 165px;
            min-height: 90px;
        }
    }

    .r-content {
        .date {
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            text-align: left;
            margin-right: 40px;
        }

    }


}
</style>